import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EventCalendarHomepageComponent } from 'app/events/event-calendar-homepage/event-calendar-homepage.component';
import { EventListComponent } from 'app/events/event-list/event-list.component';
import { EventComponent } from 'app/events/event/event.component';

import { DashboardComponent } from './dashboard.component';

const routes: Routes = [
  { path: '', 
  component: DashboardComponent,
    
 },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule { }

export const routedComponents = [DashboardComponent];



// WEBPACK FOOTER //
// ./src/app/dashboard/dashboard-routing.module.ts